// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".omvcsdk .col-4[data-v-c1e61254]{padding-left:0!important;padding-right:0!important}.chart-legend[data-v-c1e61254]{display:flex;align-items:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
